import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {SearchMethod} from "../../../search/types/SearchMethod";
import {PricesCityAnalyticsLocation} from "./prices_city_analytics";
import {PRICES_HUB_ANALYTICS_LOCATION} from "./prices_hub_analytics";

/** Screens the prices search lives on: the hub now, the city and district heroes later. */
export type PricesSearchAnalyticsLocation = typeof PRICES_HUB_ANALYTICS_LOCATION | PricesCityAnalyticsLocation;

export type PricesSearchMethod = Extract<SearchMethod, "manual_input" | "popular_search_click" | "recent_search_click">;

interface ITrackPricesSearchParams {
    location: PricesSearchAnalyticsLocation;
    /** The resolved choice as displayed, not the typed phrase - "gda" confirmed as Gdańsk is sent as Gdańsk, an address as "Puławska 257, Warszawa". */
    searchQuery: string;
    /** A popular row or chip - `popular_search_click`, a recent row - `recent_search_click`, anything else - `manual_input`. */
    searchMethod: PricesSearchMethod;
}

export const trackPricesSearch = (params: ITrackPricesSearchParams) => {
    trackAmplitudeEvent("global_search", {
        location: params.location,
        search_query: params.searchQuery,
        search_method: params.searchMethod
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {SearchMethod} from "../../../search/types/SearchMethod";
import {PricesCityAnalyticsLocation} from "./prices_city_analytics";
import {PRICES_HUB_ANALYTICS_LOCATION} from "./prices_hub_analytics";

/** Screens the prices search lives on: the hub now, the city and district heroes later. */
export type PricesSearchAnalyticsLocation = typeof PRICES_HUB_ANALYTICS_LOCATION | PricesCityAnalyticsLocation;

export type PricesSearchMethod = Extract<SearchMethod, "manual_input" | "popular_search_click" | "recent_search_click">;

interface ITrackPricesSearchParams {
    location: PricesSearchAnalyticsLocation;
    /** The resolved choice as displayed, not the typed phrase - "gda" confirmed as Gdańsk is sent as Gdańsk, an address as "Puławska 257, Warszawa". */
    searchQuery: string;
    /** A popular row or chip - `popular_search_click`, a recent row - `recent_search_click`, anything else - `manual_input`. */
    searchMethod: PricesSearchMethod;
}

export const trackPricesSearch = (params: ITrackPricesSearchParams) => {
    trackAmplitudeEvent("global_search", {
        location: params.location,
        search_query: params.searchQuery,
        search_method: params.searchMethod
    });
};
